import { fetchHideRating, THideRatingResponse } from '../../repositories/cian-chat-bot/v1/hide-rating';
import { IApplicationContext } from '../../types/applicationContext';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { ETelemetryEvents } from '../../types/telemetry';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

const DEFAULT_ERROR_MESSAGE = 'Ошибка при отправке события закрытия окна с оценкой чатбота';

export async function fetchCloseRating({ httpApi, logger, telemetry }: IApplicationContext): Promise<void> {
  try {
    const { response, statusCode }: THideRatingResponse = await fetchHideRating({
      httpApi,
    });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.Chatbot,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }
  } catch (error) {
    telemetry.increment(ETelemetryEvents.ChatbotCloseRatingFail);

    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.Chatbot,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'cian-chat-bot',
      pathApi: '/v1/hide-rating/',
    });
  }
}
